import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';
import { FormattedDate } from 'react-intl';

import DatePicker from 'material-ui/DatePicker';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import TextField from 'material-ui/TextField';

import SortAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';

const sortMethods = {
    default:    (a, b) => a.id - b.id,
    fullName:   (a, b) => a.fullName.localeCompare(b.fullName),
    moduleName: (a, b) => !!a.moduleName ? a.moduleName.localeCompare(b.moduleName) : !!b.moduleName,
    eventName:  (a, b) => a.eventName.localeCompare(b.eventName),
    eventDate:  (a, b) => a.eventDate.localeCompare(b.eventDate)
};

class ReportEventAttendanceHistory extends Component {
    constructor() {
        super(...arguments);

        this.state = {
            sortName: 'default',
            sort: sortMethods.default,
            statuses: ['waiting', 'attending', 'attended', 'did_not_attend', 'cancelled'],
            filters: {
                fullName: '',
                email: '',
                moduleName: '',
                eventName: '',
                eventFrom: '',
                eventFromTime: 0,
                eventTo: '',
                eventToTime: 0,
                registrationFrom: '',
                registrationFromTime: 0,
                registrationTo: '',
                registrationToTime: 0,
                attendanceStatus: ''
            }
        };
    }

    componentDidMount() {
        this.setSort = this.setSort.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.filterData = this.filterData.bind(this);
    }

    render() {
        const data = this.props.data
            .filter(this.filterData)
            .sort(this.state.sort);

        const tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        let tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        const tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };

        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }

        const style = { width: '100%' };
        const textFilterProps = {
            hintText: 'Filter',
            onChange: (event) => this.setFilter(event.target.name, event.target.value.toLocaleLowerCase()),
            style
        };
        const dropdownFilterProps = {
            hintText: 'Filter',
            onChange: (event, i, value) => this.setFilter('attendanceStatus', value),
            style
        };
        const dateFilterProps = {
            formatDate:     (date) => (date instanceof Date ? date.toLocaleDateString() : null),
            style,
            textFieldStyle: style
        };

        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>Name
                            <IconButton onTouchTap={this.setSort('fullName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Email address</TableHeaderColumn>
                        <TableHeaderColumn>Module name
                            <IconButton onTouchTap={this.setSort('moduleName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Event name
                            <IconButton onTouchTap={this.setSort('eventName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Event date
                            <IconButton onTouchTap={this.setSort('eventDate')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Registration date</TableHeaderColumn>
                        <TableHeaderColumn>Attendance status</TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                        <TableHeaderColumn>
                            <TextField name="fullName" value={this.state.filters.fullName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="email" value={this.state.filters.email} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="moduleName" value={this.state.filters.moduleName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="eventName" value={this.state.filters.eventName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={(e,v) => this.setFilter('eventFrom', v)} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={(e,v) => this.setFilter('eventTo', v)}   {...dateFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={(e,v) => this.setFilter('registrationFrom', v)} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={(e,v) => this.setFilter('registrationTo', v)}   {...dateFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <SelectField name="attendanceStatus" value={this.state.filters.attendanceStatus} {...dropdownFilterProps}>
                                <MenuItem value="" primaryText="No filter" label=" " />
                                {this.state.statuses.map((status, index) => <MenuItem key={index} value={status} primaryText={status} />)}
                            </SelectField>
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map((row, index) => (
                        <TableRow key={index} selected={row.selected} style={{color: !row.archived ? statusColours.default : statusColours.waiting}}>
                            <TableRowColumn>
                                {!row.archived
                                    ? row.fullName
                                    : <span title="Archived user">{row.fullName}</span>
                                }
                            </TableRowColumn>
                            <TableRowColumn>{row.email}</TableRowColumn>
                            <TableRowColumn>{row.moduleName}</TableRowColumn>
                            <TableRowColumn>{row.eventName}</TableRowColumn>
                            <TableRowColumn>
                                {(!!row.eventDate && !isNaN(Date.parse(row.eventDate))) && (
                                    <FormattedDate {...DateStyles.long} value={row.eventDate} />
                                )}
                            </TableRowColumn>
                            <TableRowColumn>
                                {(!!row.registrationDate && !isNaN(Date.parse(row.registrationDate))) && (
                                    <FormattedDate {...DateStyles.long} value={row.registrationDate} />
                                )}
                            </TableRowColumn>
                            <TableRowColumn>{row.attendanceStatus}</TableRowColumn>
                        </TableRow>
                    ))}
                </TableBody>

            </Table>
        );
    }

    setSort(sort) {
        return () => {
            if (sortMethods.hasOwnProperty(sort) && this.state.sortName !== sort) {
                this.setState({sortName: sort, sort: sortMethods[sort]});
            }
        };
    }

    setFilter(filter, value) {
        if (this.state.filters.hasOwnProperty(filter)) {
            const filters = {
                ...this.state.filters,
                [filter]: value
            };
            const time = `${filter}Time`;
            if (filters.hasOwnProperty(time)) {
                filters[time] = (value instanceof Date ? value.getTime() : '');
            }
            this.setState({filters: filters});
        }
    }

    filterData(row) {
        if (row === undefined) { return; }
        let valid = true;
        if (valid && !!this.state.filters.fullName) {
            valid = (-1 < row.fullName.toLocaleLowerCase().search(this.state.filters.fullName));
        }

        if (valid && !!this.state.filters.email) {
            valid = (-1 < row.email.toLocaleLowerCase().search(this.state.filters.email));
        }

        if (valid && !!this.state.filters.moduleName) {
            valid = (!!row.moduleName && -1 < row.moduleName.toLocaleLowerCase().search(this.state.filters.moduleName));
        }

        if (valid && !!this.state.filters.eventName) {
            valid = (-1 < row.eventName.toLocaleLowerCase().search(this.state.filters.eventName));
        }

        if (valid && !!this.state.filters.attendanceStatus) {
            valid = row.attendanceStatus === this.state.filters.attendanceStatus;
        }

        const eventDate = (new Date(row.eventDate)).setHours(0, 0, 0);
        if (valid && !!this.state.filters.eventFrom) {
            valid = (!!eventDate && this.state.filters.eventFromTime <= eventDate);
        }
        if (valid && !!this.state.filters.eventTo) {
            valid = (!!eventDate && eventDate <= this.state.filters.eventToTime );
        }

        const registered = (new Date(row.registrationDate)).setHours(0, 0, 0);
        if (valid && !!this.state.filters.registrationFrom) {
            valid = (!!registered && this.state.filters.registrationFromTime <= registered);
        }
        if (valid && !!this.state.filters.registrationTo) {
            valid = (!!registered && registered <= this.state.filters.registrationToTime );
        }

        return valid;
    }
}

ReportEventAttendanceHistory.propTypes = {
    display: PropTypes.object,
    onRowSelect: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
};

ReportEventAttendanceHistory.defaultProps = {
    display: {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        showCheckboxes: false,
        selectable: false,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: false,
    },
    data: []
};
export default ReportEventAttendanceHistory;
